import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function useDongengFavorites() {
  const { user } = useAuth();
  const [favorites, setFavorites] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) { setFavorites(new Set()); return; }
    setLoading(true);
    fetch('/api/dongeng/favorites')
      .then(r => r.json())
      .then(d => { if (d.ok) setFavorites(new Set(d.favorites as string[])); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user]);

  const toggleFavorite = useCallback(async (videoId: string): Promise<boolean | null> => {
    if (!user) return null; // null = not logged in
    try {
      const res  = await fetch(`/api/dongeng/favorites/${videoId}`, { method: 'POST' });
      const data = await res.json();
      setFavorites(prev => {
        const next = new Set(prev);
        if (data.favorited) next.add(videoId);
        else next.delete(videoId);
        return next;
      });
      return data.favorited;
    } catch {
      return null;
    }
  }, [user]);

  const isFavorite = useCallback((videoId: string) => favorites.has(videoId), [favorites]);

  return { isFavorite, toggleFavorite, loading };
}
